import { createFileRoute } from '@tanstack/react-router'
import { interventionKeys, QUERY_TIMING } from '@/hooks/interventions'
import {
  fetchInterventionFull,
  retryInterventionFull,
} from '@/hooks/interventions/requests/useGetInterventionFull'
import { setEntityTag } from '@/lib/sentry/entity-tags'

export type InterventionTabs =
  | 'activity'
  | 'details'
  | 'facturation'
  | 'notes'
  | 'internal-notes'
  | 'signalements'
  | 'documents'
  | 'quotes'
  | 'invoices'
  | 'prise-en-charge'
  | 'technicians'
  | 'dispatch'
  | 'report'

const allowedTabs: InterventionTabs[] = [
  'activity',
  'details',
  'facturation',
  'notes',
  'internal-notes',
  'signalements',
  'documents',
  'quotes',
  'invoices',
  'prise-en-charge',
  'technicians',
  'dispatch',
  'report',
]

export type InterventionSearch = {
  tab: InterventionTabs
  documentType?: string
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/interventions/$interventionId'
)({
  validateSearch: (search: Record<string, unknown>): InterventionSearch => {
    const { tab, documentType } = search

    const validatedTab = allowedTabs.includes(tab as InterventionTabs)
      ? (tab as InterventionTabs)
      : 'details'

    return {
      tab: validatedTab,
      documentType: typeof documentType === 'string' ? documentType : undefined,
    }
  },
  pendingMinMs: 0,
  loader: async ({ context: { queryClient }, params: { interventionId } }) => {
    // Tag Sentry so any error on this detail view filters to the intervention.
    setEntityTag('intervention', interventionId)
    queryClient.prefetchQuery({
      queryKey: interventionKeys.full(interventionId),
      queryFn: () => fetchInterventionFull(interventionId),
      staleTime: QUERY_TIMING.STALE_TIME.FULL,
      retry: retryInterventionFull,
    })
  },
})
